import { __awaiter } from "tslib";
import ReactDOM from 'react-dom';
import React from 'react';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { ALL_ADD_TO_MY_FANDOMS_MODULES_VARIANTS } from 'pathfinder/rules-engine/modules/addToMyFandoms';
import getOptimizelyVariant from 'pathfinder/utils/getOptimizelyVariant';
import { ADD_TO_MY_FANDOMS_OPTIMIZELY_VARIABLES } from './types';
import { hasCurrentWikiInMyFandoms, removeCurrentWikiFromMyFandoms, saveCurrentWikiToMyFandoms, } from './utils/fandomsStorage';
import AddToMyFandomsRoot from './components/AddToMyFandomsRoot';
export const getAddToMyFandomsModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const isForced = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced;
    const moduleProps = buildModuleProps(moduleConfig);
    const { log, track } = moduleProps;
    try {
        const variant = yield getOptimizelyVariant(isForced, ADD_TO_MY_FANDOMS_OPTIMIZELY_VARIABLES, ALL_ADD_TO_MY_FANDOMS_MODULES_VARIANTS);
        if (!variant) {
            log.debug('Not displayed due to no variant (Optimizely experiment is disabled)');
            return null;
        }
        // if we're not this variant, just bail
        if (variant !== moduleConfig.name) {
            log.debug('Not displayed due to variant mismatch (this variant is not enabled)');
            return null;
        }
        const props = {
            track,
            // replace variant names from optimizely and unify it with `ADD_TO_MY_FANDOMS_MODULES_VARIANTS`
            variant: variant.replace('-desktop', '').replace('-mobile', ''),
            initialActiveState: yield hasCurrentWikiInMyFandoms(),
            doAddToMyFandoms: () => {
                saveCurrentWikiToMyFandoms().then(() => {
                    log.debug('Added to my fandoms (on server)');
                });
            },
            doRemoveFromMyFandoms: () => {
                removeCurrentWikiFromMyFandoms().then(() => {
                    log.debug('Removed from my fandoms (on server)');
                });
            },
        };
        /*
        Desktop:
        - BEFORE .fandom-sticky-header .wiki-tools
            button
        - BEFORE .fandom-community-header .page-counter
            spacer (flex-grow: 1)
            button
        Mobile:
        - Add third line of clamp to `.mobile-community-bar__sitename`
        - BEFORE .mobile-global-navigation__button-search
            button
        - BEFORE .mobile-community-bar .mobile-community-bar__discussions
            button
        */
        const render = () => {
            if (variant.endsWith('-desktop')) {
                log.debug('Attempting to attach to desktop elements');
                // desktop non-sticky
                const nonStickyDesktop = document.querySelector('.fandom-community-header__top-container .page-counter');
                if (nonStickyDesktop) {
                    const desktopNonStickyRoot = document.createElement('div');
                    desktopNonStickyRoot.style.position = 'relative';
                    const nonStickySpacer = document.createElement('div');
                    nonStickySpacer.style.flexGrow = '1';
                    nonStickyDesktop.insertAdjacentElement('beforebegin', nonStickySpacer);
                    nonStickyDesktop.insertAdjacentElement('beforebegin', desktopNonStickyRoot);
                    props.desktopNonStickyRoot = desktopNonStickyRoot;
                }
                // desktop sticky
                const stickyDesktop = document.querySelector(' .fandom-sticky-header .wiki-tools');
                if (stickyDesktop) {
                    const desktopStickyRoot = document.createElement('div');
                    desktopStickyRoot.style.position = 'relative';
                    stickyDesktop.insertAdjacentElement('beforebegin', desktopStickyRoot);
                    props.desktopStickyRoot = desktopStickyRoot;
                }
            }
            if (variant.endsWith('-mobile')) {
                log.debug('Attempting to attach to mobile elements');
                // mobile overrides
                const mobileSitename = document.querySelector('.mobile-community-bar__sitename');
                if (mobileSitename) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    mobileSitename.style.webkitLineClamp = '3';
                }
                // mobile sticky
                // .is-community-bar-in
                const stickyMobile = document.querySelector('.mobile-global-navigation__community-bar-wrapper .mobile-global-navigation__buttons');
                if (stickyMobile) {
                    const mobileStickyRoot = document.createElement('div');
                    mobileStickyRoot.style.position = 'relative';
                    stickyMobile.insertAdjacentElement('afterbegin', mobileStickyRoot);
                    props.mobileStickyRoot = mobileStickyRoot;
                }
                // mobile non-sticky
                const nonStickyMobile = document.querySelector(' .mobile-community-bar .mobile-community-bar__discussions');
                if (nonStickyMobile) {
                    const mobileNonStickyRoot = document.createElement('div');
                    mobileNonStickyRoot.style.position = 'relative';
                    nonStickyMobile.insertAdjacentElement('beforebegin', mobileNonStickyRoot);
                    props.mobileNonStickyRoot = mobileNonStickyRoot;
                }
            }
            if (!props.desktopStickyRoot &&
                !props.desktopNonStickyRoot &&
                !props.mobileStickyRoot &&
                !props.mobileNonStickyRoot) {
                log.debug('Not displayed due to no root element, probably wrong variant');
                return null;
            }
            log.debug('Redered with', props);
            // render everything
            const reactRoot = document.createElement('div');
            ReactDOM.render(React.createElement(AddToMyFandomsRoot, props), reactRoot);
            return reactRoot;
        };
        return {
            render,
        };
    }
    catch (error) {
        log.error('AddToMyFandoms error', error);
    }
    return null;
});
